import { SAMPLES_DETAIL } from '../../../../../routes/paths';
import { Table } from '../../../../components/general/table';
import { SamplesListProps } from './props';
import { useSamplesList } from './hook';

export const SamplesList = ({ filters }: SamplesListProps) => {
    const { columns, rows, loading, page, pageSize, paginator, total } =
        useSamplesList(filters);

    return (
        <Table
            columns={columns}
            rows={rows}
            rowCount={total}
            loading={loading}
            paginationModel={{
                page,
                pageSize,
            }}
            onPaginationModelChange={paginator}
            pageSizeOptions={[2, 10, 20, 50]}
            disableRowSelectionOnClick
            onRowClick={(item) =>
                window.open(`${SAMPLES_DETAIL}/${item.row.id}`, '_blank')
            }
        />
    );
};
